import { ReplaySubject } from 'rxjs/ReplaySubject';
import { enCurrency } from 'interfaces/IProductData';
import { Observable } from 'rxjs/Observable';
import { Cookies } from 'react-cookie';

const cookie = new Cookies();

export class CurrencyService {
  private currency$ = new ReplaySubject<enCurrency>(1);

  constructor() {
    let currency = enCurrency.BRL;

    try {
      currency = (cookie.get('currency') as enCurrency) || enCurrency.BRL;
    } catch (err) {}

    this.setCurrency(currency);
  }

  public setCurrency(currency: enCurrency) {
    try {
      cookie.set('currency', currency, {
        maxAge: 864000
      });
    } catch (err) {}

    this.currency$.next(currency);
  }

  public getCurrency(): Observable<enCurrency> {
    return this.currency$.asObservable().distinctUntilChanged();
  }
}

// tslint:disable-next-line:variable-name
export const CurrencyServiceFactory = () => new CurrencyService();

export const currencyService = CurrencyServiceFactory();
